// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================

import * as THREE from "three";
import TWEEN from "@tweenjs/tween.js";
import { getAsset } from "../getAsset";

export class Gizmo extends EventTarget {
  constructor() {
    super();
    this.gizmo = document.createElement("div");
    // this.gizmo.style.width = this.gizmo.style.height = "100px";
    // this.gizmo.style.position = "absolute";
    // this.gizmo.style.left = "300px";
    // this.gizmo.style.bottom = "10px";
    this.gizmo.classList.add("gizmo");
    this.controls = null;

    this.gscene = new THREE.Scene();
    this.gcamera = new THREE.PerspectiveCamera(40, 1, 0.1, 4000);
    this.gcamera.position.set(0, 0, 1);
    this.grenderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    this.grenderer.setPixelRatio(window.devicePixelRatio);

    this.views = {
      front: { x: 0, y: 0, z: 12 },
      back: { x: 0, y: 0, z: -12 },
      left: { x: 12, y: 0, z: 0 },
      right: { x: -12, y: 0, z: 0 },
      up: { x: 0, y: 12, z: 0 },
      down: { x: 0, y: -12, z: 0 },
      prespective: { x: 6, y: 6, z: 6 },
    };

    this.gcanvas = this.grenderer.domElement;
    this.gcanvas.id = "gcanvas";
    this.gcanvas.classList.add("gizmoCanvas");
    // this.gcanvas.style.width = "100px";
    // this.gcanvas.style.height = "100px";
    this.gscene.add(new THREE.AmbientLight(0xffffff, 0.75));
    this.gbox = new THREE.Group();

    this.gscene.add(this.gbox);
    this.gizmo.appendChild(this.gcanvas);

    addPlane(this.gbox, "front");
    addPlane(this.gbox, "back");
    addPlane(this.gbox, "left");
    addPlane(this.gbox, "right");
    addPlane(this.gbox, "up");
    addPlane(this.gbox, "down");

    function addPlane(box, side) {
      var degree2Radian = Math.PI / 180;
      var s = 0.4;
      var l = 0.8;
      box.scale.set(s, s, s);
      let geometry = new THREE.PlaneGeometry(l, l);
      let textureLoader = new THREE.TextureLoader();
      let texture = textureLoader.load(getAsset(side + ".jpg", "images"));
      let material = new THREE.MeshBasicMaterial({
        map: texture,
        side: THREE.DoubleSide,
      });
      let plane = new THREE.Mesh(geometry, material);
      if (side === "front") {
        plane.position.z = 0.4;
      } else if (side === "back") {
        plane.position.z = -0.4;
        plane.rotation.y = -180 * degree2Radian;
      } else if (side === "left") {
        plane.position.x = 0.4;
        plane.rotation.y = 90 * degree2Radian;
      } else if (side === "right") {
        plane.position.x = -0.4;
        plane.rotation.y = -90 * degree2Radian;
      } else if (side === "up") {
        plane.position.y = 0.4;
        plane.rotation.x = -90 * degree2Radian;
      } else if (side === "down") {
        plane.position.y = -0.4;
        plane.rotation.x = 90 * degree2Radian;
      }
      plane.name = side;
      box.add(plane);
    }
  }

  moveToView(t, camera, controls) {
    let target = this.views[t];
    const spherical = new THREE.Spherical();
    const offset = new THREE.Vector3();
    offset.copy(camera.position).sub(controls.target);
    spherical.setFromVector3(offset);

    // Calculate target spherical angles
    const targetOffset = new THREE.Vector3(target.x, target.y, target.z);
    const targetSpherical = new THREE.Spherical();
    targetSpherical.setFromVector3(targetOffset);

    const tween = new TWEEN.Tween({
      radius: spherical.radius,
      phi: spherical.phi,
      theta: spherical.theta,
    })
      .to(
        {
          radius: targetSpherical.radius,
          phi: targetSpherical.phi,
          theta: targetSpherical.theta,
        },
        1000,
      )
      .easing(TWEEN.Easing.Quadratic.InOut)
      .onUpdate(function (obj) {
        spherical.radius = obj.radius;
        spherical.phi = obj.phi;
        spherical.theta = obj.theta;

        const newPos = new THREE.Vector3().setFromSpherical(spherical);
        camera.position.copy(newPos.add(controls.target));
        camera.lookAt(controls.target);
        controls.update();
      })
      .start();
  }
  get spinGizmo() {
    return null;
  }
  set spinGizmo(camera) {
    this.gcamera.updateMatrixWorld();
    this.gbox.quaternion.copy(camera.quaternion).invert();
    this.grenderer.render(this.gscene, this.gcamera);
  }
  get canvas() {
    return this.gcanvas;
  }
  set canvas(v) {}
  get renderer() {
    return this.grenderer;
  }
  set renderer(v) {}
  get scene() {
    return this.gscene;
  }
  set scene(v) {}
  get camera() {
    return this.gcamera;
  }
  set camera(v) {}

  show(v) {
    this.gizmo.style.display = v ? "flex" : "none";
  }

  get box() {
    return this.gbox;
  }
  set box(v) {}
  appendTo(parent) {
    if (parent instanceof HTMLElement) {
      parent.appendChild(this.gizmo);
    } else {
      console.error("Invalid parent element. It must be an HTMLElement.");
    }
  }
}
